import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import PortfolioSection from "./components/PortfolioSection";
import FAQSection from "./components/FAQSection";
import EstimateSection from "./components/EstimateSection";
import Footer from "./components/Footer";
import FloatingCall from "./components/FloatingCall";

const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "착한누수",
  "url": siteUrl,
  "description": "서울·경기·수도권 전지역 24시간 연중무휴 누수탐지 전문업체. 비파괴 음파 탐지기, 열화상 카메라로 정확한 누수 위치 탐지.",
  "inLanguage": "ko-KR",
  "publisher": {
    "@type": "Organization",
    "name": "착한누수",
    "telephone": "010-2684-4892",
    "url": siteUrl
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "PlumbingService",
  "name": "착한누수",
  "url": siteUrl,
  "telephone": "010-2684-4892",
  "description": "서울·경기·수도권 전지역 24시간 연중무휴 누수탐지 전문업체. 비파괴 음파 탐지기, 열화상 카메라로 정확한 누수 위치 탐지. 아파트·빌라·상가·단독주택 누수 당일 해결.",
  "image": "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/fad0df4cf3eccde6aaa12f325ac46c67.jpeg",
  "logo": "https://static.readdy.ai/image/cb00bb43b5785578e6b0c78f29ebff63/fad0df4cf3eccde6aaa12f325ac46c67.jpeg",
  "priceRange": "₩₩",
  "currenciesAccepted": "KRW",
  "paymentAccepted": "현금, 계좌이체, 카드",
  "areaServed": [
    { "@type": "State", "name": "서울특별시" },
    { "@type": "State", "name": "경기도" },
    { "@type": "State", "name": "인천광역시" }
  ],
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 37.5665,
    "longitude": 126.9780
  },
  "address": {
    "@type": "PostalAddress",
    "addressRegion": "서울특별시",
    "addressCountry": "KR"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      "opens": "00:00",
      "closes": "23:59"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "누수탐지 및 보수 서비스",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "비파괴 누수탐지" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "아파트 층간 누수 보수" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "방수 시공" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "배수구 막힘 해결" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "동파 수리" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "피해복구 시공" } }
    ]
  },
  "sameAs": [siteUrl]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "야간이나 주말에도 출동이 가능한가요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "네, 365일 24시간 연중무휴로 운영됩니다. 야간, 공휴일, 명절 등 언제든지 연락 주시면 즉시 출동합니다."
      }
    },
    {
      "@type": "Question",
      "name": "누수 원인을 어떻게 찾나요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "비파괴 음파 탐지기와 열화상 카메라를 사용해 벽이나 바닥을 손상하지 않고 정확한 누수 위치를 찾아냅니다."
      }
    },
    {
      "@type": "Question",
      "name": "아파트 층간 누수는 어떻게 처리하나요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "비파괴 탐지로 정확한 위치를 확인한 후, 최소한의 개구부로 보수합니다. 위층 아래층 모두 조율하여 진행하며 마무리까지 깔끔하게 처리합니다."
      }
    },
    {
      "@type": "Question",
      "name": "시공 후 AS는 어떻게 되나요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "시공 완료 후 보증서를 제공하며, 동일 부위에서 재발 시 무상으로 재보수해드립니다. 고객 만족이 최우선입니다."
      }
    },
    {
      "@type": "Question",
      "name": "서울 경기 외 지역도 출동이 가능한가요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "기본적으로 서울·경기·인천 수도권 전지역을 커버합니다. 그 외 지역은 전화 상담 시 출동 가능 여부를 확인해드립니다."
      }
    },
    {
      "@type": "Question",
      "name": "견적을 미리 받을 수 있나요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "현장 탐지 전 정확한 견적은 어렵지만, 전화 상담을 통해 대략적인 비용 범위와 작업 내용을 미리 안내해드릴 수 있습니다."
      }
    },
    {
      "@type": "Question",
      "name": "보험으로 처리가 가능한가요?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "누수 원인과 상황에 따라 화재보험(풍수해보험)으로 처리가 가능한 경우가 있습니다. 시공 전 상담 시 보험 적용 여부를 함께 검토해드립니다."
      }
    }
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="min-h-screen">
        <Navbar />
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <PortfolioSection />
        <FAQSection />
        <EstimateSection />
        <Footer />
        <FloatingCall />
      </div>
    </>
  );
}
